import { loaderService } from "../../common/custom-loader/loader-service";
import {
  authKey,
  UPDATE_PAID_STATUS,
  GET_PAYMENT_PO_LIST,
  GET_PARTIALLY_PAID,
  PRINT_DOWNLOAD_DATA,
  GET_CONFIG_BY_SERVICE_TYPE,
  GET_APPROVED_STAKEHOLDERS,
  SAVE_ADVANCE_PAYMENT,
  GET_ALL_PAYMENT_REQUEST,
  SEND_FOR_PAYMENT_APPROVAL,
  CANCEL_PAYMENT,
  UPLOAD_DCUMENT,
  DOWNLOAD_DOCUMENT,
  SEND_TO_SAP_FOR_PAYEMENT,
  GET_INVOICE_PAYMENT,
  GET_PAYMENT_STATUS,
  SEND_INVOICE_PAYMENT_TO_SAP,
  PRINT_PAYMENT_DATA,
  PRINT_PAYMENT_DATA_EXCEL,
  GET_INVOICE_PAYMENTS_WITH_PAGING,
  GET_PAYMENT_STATUS_WITH_PAGING,
  SEND_LLE_PAYMENT_TO_SAP,
  GET_INVOICE_PAYMENT_BY_GROUP_ID,
} from "../../common/URLs";

import { toast } from "react-toastify";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { API_DATE_FORMAT, BASIC_DATE_FORMAT } from "../../common/constants";
import moment from "moment";
import apiClient from "../../axios";
// import { setAriaRowCount } from "ag-grid-community/dist/lib/utils/aria";
import { UPDATE_PAYMENT_PROCESS_STATUS } from "../../common/constants";

export const getPrint = (invoiceArr) => {
  loaderService.showLoader();
  apiClient
    .post(
      PRINT_PAYMENT_DATA,
      {
        invoiceList: invoiceArr,
      },
      {
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),

          // Accept: 'application/pdf'
        },
      },
      null
    )
    .then((response) => {
      const url = URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      let iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.style.display = "none";
      iframe.src = url;
      iframe.onload = function () {
        setTimeout(function () {
          iframe.focus();
          iframe.contentWindow.print();
        }, 1);
      };
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
      toast.error(error.message);
    });
};
export const downloadExcel = (invoiceArr, setExcelDownloaded) => {
  loaderService.showLoader();
  apiClient
    .post(
      PRINT_PAYMENT_DATA_EXCEL,
      {
        invoiceList: invoiceArr,
      },
      {
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      },
      null
    )
    .then((response) => {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.innerText = "Open the array URL";
      link.setAttribute("download", "Payment.xlsx");
      link.click();
      loaderService.hideLoader();
      setExcelDownloaded(true);
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
      toast.error(error.message);
    });
};

export function updatePaidStatus(
  paymentArr,
  details,
  callbackStatusUpdate
) {
  loaderService.showLoader();
  apiClient
    .post(
      UPDATE_PAID_STATUS,
      {
        PaymentRequests: paymentArr,
        bankTransactionID: details.bankTransactionID,
        paymentDate: details.status == "Paid" ? moment(details.paymentDate).format(API_DATE_FORMAT) : null,
        loginID: localStorage.getItem("uuid"),
        status: details.status,
        comment: details.comment
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      }
    )
    .then((response) => {
      loaderService.hideLoader();
      if (response.data.isSuccess) {
        toast.success("Successfully processed!");
        callbackStatusUpdate();
      } else toast.error("Error! Please try again");
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}

export function getCategoryList(setCategoryList) {
  loaderService.showLoader();
  apiClient
    .post(
      GET_CONFIG_BY_SERVICE_TYPE,
      {
        serviceType: "stakeholder_type",
      },
      {
        headers: {
          AuthKey: authKey,
        },
      }
    )
    .then((response) => {
      setCategoryList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getUrnList(category, setUrnList) {
  loaderService.showLoader();
  apiClient
    .post(
      GET_APPROVED_STAKEHOLDERS,
      {
        type: category,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setUrnList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function saveAdvancePayment(
  details,
  selectedUrn,
  selectedPo,
  documents,
  setSaveResponse,
  selectedRowForEdit,
  paymentType,
  navigate,
  poItem,
  partiallyPaid
) {
  loaderService.showLoader();
  apiClient
    .post(
      SAVE_ADVANCE_PAYMENT,
      {
        paymentDTOs: [
          {
            id: selectedRowForEdit ? selectedRowForEdit?.id : null,
            stakeholderCatgeory: selectedRowForEdit
              ? selectedRowForEdit?.stakeholderCatgeory
              : details?.category,
            urn: selectedRowForEdit ? selectedRowForEdit?.urn : details?.urn,
            stakeholderName: selectedRowForEdit
              ? selectedRowForEdit?.stakeholderName
              : selectedUrn?.name,
            pitPono: selectedRowForEdit
              ? selectedRowForEdit?.pitPono
              : poItem?.poNumber,
            advancePaymentAmount: details?.advancePaymentAmount,
            requesterRemark: details?.requesterRemark,
            paymentType: paymentType,
            paymentRequestId: selectedRowForEdit
              ? selectedRowForEdit?.paymentRequestId
              : null,
            status: selectedRowForEdit ? selectedRowForEdit?.status : null,
            assignedTo: selectedRowForEdit
              ? selectedRowForEdit?.assignedTo
              : null,
            approveAmount: selectedRowForEdit
              ? selectedRowForEdit?.approveAmount
              : null,
            approverRemark: selectedRowForEdit
              ? selectedRowForEdit?.approverRemark
              : null,
            paymentMode: selectedRowForEdit
              ? selectedRowForEdit?.paymentMode
              : null,
            isActive: true,
            poAdvancePaymentAmount: poItem?.advanceAmount,
            poDescription: poItem?.poDescription,
            poPartiallyPaidAmount: partiallyPaid,
            paymentCycle: poItem?.paymentCycle,
            poDate: poItem?.poStartDate,
            poAmount: poItem?.poAmount,
            sapPoNumber: poItem?.sapPoNumber,
            documents: documents,
          },
        ],
        loggedInUserID: localStorage.getItem("uuid"),
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setSaveResponse(response.data);
      response?.data?.isSuccess === true
        ? toast.success(response?.data?.message)
        : toast.error(response?.data?.message);
      navigate(`../${paymentType.toLowerCase()}Payment`);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getAllPaymentRequest(paymentType, setPaymentTableDetails) {
  loaderService.showLoader();
  apiClient
    .post(
      GET_ALL_PAYMENT_REQUEST,
      {
        loginId: localStorage.getItem("uuid"),
        paymentType: paymentType,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setPaymentTableDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function sendForPaymentApproval(
  idsArray,
  action,
  setActionResponse,
  paymentType,
  setPaymentTableDetails,
  navigate
) {
  loaderService.showLoader();
  apiClient
    .post(
      SEND_FOR_PAYMENT_APPROVAL,
      {
        approvals: idsArray,
        status: action !== "sendForApproval" ? action : null,
        loginId: localStorage.getItem("uuid"),
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setActionResponse(response.data);
      response?.data?.isSuccess === true
        ? toast.success(response?.data?.message)
        : toast.error(response?.data?.message);
      setPaymentTableDetails !== null
        ? getAllPaymentRequest(paymentType, setPaymentTableDetails)
        : navigate(`../${paymentType.toLowerCase()}Payment`);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function cancelPayment(
  idsArray,
  setActionResponse,
  paymentType,
  setPaymentTableDetails
) {
  loaderService.showLoader();
  apiClient
    .post(
      CANCEL_PAYMENT,
      {
        paymentId: idsArray,
        loggedInUserID: localStorage.getItem("uuid"),
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setActionResponse(response.data);
      response?.data?.isSuccess === true
        ? toast.success(response?.data?.message)
        : toast.error(response?.data?.message);
      getAllPaymentRequest(paymentType, setPaymentTableDetails);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getDocumentUploadDetails(
  file,
  selectedFiles,
  setSelectedFiles
) {
  loaderService.showLoader();
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", file.name);
  formData.append("containerName", "paymentfiles");
  apiClient
    .post(UPLOAD_DCUMENT, formData, {
      headers: {
        AuthKey: authKey,
      },
    })
    .then((response) => {
      response?.data?.isSuccess === true
        ? toast.success(response?.data?.message)
        : toast.error(response?.data?.message);
      // response?.data?.isSuccess === true &&
      if (response?.data?.isSuccess === true) {
        const blobResponse = response?.data?.blobResponse;
        const tempArr = [...selectedFiles];
        tempArr.push({
          ...blobResponse,
        });
        setSelectedFiles(tempArr);
      }
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export const downloadDocument = (file, type) => {
  console.log("file", file);
  loaderService.showLoader();
  return fetch(DOWNLOAD_DOCUMENT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      AuthKey: authKey,
    },
    body: JSON.stringify({
      fileName: type === "Create" ? file?.blobFileName : file?.documentBlobName,
      containerName: "paymentfiles",
      file: "",
    }),
  })
    .then((response) => response.blob())
    .then((blob) => {
      const fileName = type === "Create" ? file?.fileName : file?.documentName;
      const splittedName = fileName.split(".");
      const fileExtension = splittedName[splittedName.length - 1];
      let fileType;
      switch (fileExtension) {
        case "pdf":
          fileType = "application/pdf";
          break;
        case "png":
          fileType = "image/png";
          break;
        case "jpg":
          fileType = "image/jpeg";
          break;
        case "jpeg":
          fileType = "image/jpeg";
          break;
        default:
          fileType = "application/octet-stream";
      }
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: fileType })
      );
      const newWindow = window.open(url, "_blank");
      newWindow.focus();
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
};

export function sendToSAPForPayment(
  idsArray,
  setActionResponse,
  paymentType,
  setPaymentTableDetails,
  navigate
) {
  loaderService.showLoader();
  apiClient
    .post(
      SEND_TO_SAP_FOR_PAYEMENT,
      {
        paymentSaP: idsArray,
        loginId: localStorage.getItem("uuid"),
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setActionResponse(response.data);
      response?.data?.isSuccess === true
        ? toast.success(response?.data?.message)
        : toast.error(response?.data?.message);
      setPaymentTableDetails !== null
        ? getAllPaymentRequest(paymentType, setPaymentTableDetails)
        : navigate(`../${paymentType.toLowerCase()}Payment`);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getAllInvoicePaymentRequest(setInvoicePaymentTableDetails) {
  loaderService.showLoader();
  apiClient
    .post(
      GET_INVOICE_PAYMENT,
      {
        loginId: localStorage.getItem("uuid"),
        paymentType: "",
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setInvoicePaymentTableDetails(response.data.invoicePayments);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getPaymentStatus(urn, setPaymentStatusDetails) {
  console.log("payurn", urn);
  loaderService.showLoader();
  apiClient
    .post(
      GET_PAYMENT_STATUS,
      {
        loginId: urn ? null : localStorage.getItem("uuid"),
        urn: urn,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setPaymentStatusDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

// New API for "Change to Payment Process Status"

export async function updatePaymentProcessStatus(

  payload,

  setPaymentStatusDetails,

  setSelectedRows,

  setSelectedIds

) {

  loaderService.showLoader();

  try {

    // Replace with your actual endpoint constant

    let response = await apiClient.post(

      UPDATE_PAYMENT_PROCESS_STATUS, // <-- use your backend API constant here

      payload,

      {

        headers: {

          Authorization: "Bearer " + getLocalStorageItem("id_token"),

        },

      },

      null

    );

    toast.success("Payment process status updated successfully!");

    setSelectedRows([]);

    setSelectedIds([]);

    setPaymentStatusDetails(response?.data?.paymentStatus || []);

  } catch (error) {

    console.error("Error updating payment process status:", error);

    toast.error("Failed to update payment process status!");

  } finally {

    loaderService.hideLoader();

  }

}


export async function getPaymentStatusWithPaging(urn, stakeholderType, status, paymentType, pageNumber, pageSize, sortColumn, sortDirection, filterText, setPaymentStatusDetails, setRowCount, selectedProcessedDates, searchFilter) {
  loaderService.showLoader();
  try {
    let response = await apiClient
      .post(
        GET_PAYMENT_STATUS_WITH_PAGING,
        {
          loginId: localStorage.getItem("uuid"),
          userRole: localStorage.getItem("role"),
          urn: urn,
          stakeholderType: stakeholderType,
          status: status,
          paymentType: paymentType,
          pageNumber: 0,
          pageSize: 0,
          sortColumn: sortColumn,
          sortDirection: sortDirection,
          filterText: filterText,
          paymentProcessedDates: selectedProcessedDates?.map(item => (moment(item).format(BASIC_DATE_FORMAT))),
          fromDate: searchFilter?.fromDate,
          toDate: searchFilter?.toDate,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      );
    loaderService.hideLoader();
    setPaymentStatusDetails(response.data.paymentStatus || []);
    setRowCount(response.data.totalCount || 0);
    return response.data;
  } catch (error) {
    loaderService.hideLoader();
  }
}

export function sendInvoiceToSAPForPayment(
  idsArray,
  setActionResponse,
  comment,
  setInvoicePaymentTableDetails,
  navigate
) {
  loaderService.showLoader();
  apiClient
    .post(
      SEND_INVOICE_PAYMENT_TO_SAP,
      {
        invoiceToSAPDTOs: [
          {
            invoicePaymentDetails: idsArray,
            approverComment: comment,
          },
        ],
        loginId: localStorage.getItem("uuid"),
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setActionResponse(response.data);
      response?.data?.isSuccess === true
        ? toast.success(response?.data?.message)
        : toast.error(response?.data?.message);
      //setInvoicePaymentTableDetails !== null
      //  ? getAllInvoicePaymentRequest(setInvoicePaymentTableDetails)
      //  : navigate("../invoicePayment");
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function sendLLEPaymentToSAP(
  selectedRows,
  setActionResponse,
  comment = "ok",
  setInvoicePaymentTableDetails,
  navigate
) {
  loaderService.showLoader();

  const payload = {
    invoices: [
      {
        approverComment: comment,
        lleInvoices: selectedRows?.map((item) => ({
          groupId: item?.invoicePoGroupNumber || "",
          documents: item?.documents || []
        })) || []
      }
    ],
    loginId: localStorage.getItem("uuid") || getLocalStorageItem("uuid")
  };

  apiClient
    .post(
      SEND_LLE_PAYMENT_TO_SAP,
      payload,
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      if (typeof setActionResponse === "function") {
        setActionResponse(response.data);
      }
      response?.data?.isSuccess === true
        ? toast.success(response?.data?.message)
        : toast.error(response?.data?.message);
      
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error?.response?.data?.message || error.message);
      loaderService.hideLoader();
    });
}

export function getInvoicePaymentByGroupId(invoicePoGroupNumber, setGroupInvoices) {
  loaderService.showLoader();
  apiClient
    .post(
      GET_INVOICE_PAYMENT_BY_GROUP_ID,
      {
        invoicePoGroupNumber: invoicePoGroupNumber,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setGroupInvoices(response.data?.invoicePayments || []);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function paymentPoList(stakeHolderUrn, paymentType, setPoList) {
  loaderService.showLoader();
  apiClient
    .post(
      GET_PAYMENT_PO_LIST,
      {
        stakeHolderUrn: stakeHolderUrn,
        paymentMethod: paymentType,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setPoList(response.data.paymentInvoiceDetailList);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getPartiallyPaid(
  poNumber,
  setPartiallyPaid,
  poList,
  details,
  setDetails,
  type
) {
  loaderService.showLoader();
  apiClient
    .post(
      GET_PARTIALLY_PAID,
      {
        poNo: poNumber,
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
        },
      },
      null
    )
    .then((response) => {
      setPartiallyPaid(response.data);
      setDetails({
        ...details,
        [type]: poNumber,
        advancePaymentAmount:
          Number(
            poList?.find((item) => item.poNumber === poNumber).advanceAmount
          ) - Number(response.data),
      });
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function downloadInvoice(inVoiceNumber, stakeholderCatgeory) {
  loaderService.showLoader();
  apiClient
    .post(
      PRINT_DOWNLOAD_DATA,
      {
        printDataByNumber: inVoiceNumber,
        printDetailsType:
          stakeholderCatgeory === "Transporter" || stakeholderCatgeory === "HIT"
            ? "hit_invoice"
            : stakeholderCatgeory === "LLE"
              ? "lle_invoice"
              : stakeholderCatgeory === "Grower"
                ? "grower_invoice"
                : "",
      },
      {
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + getLocalStorageItem("id_token"),
          Accept: "application/pdf",
        },
      },
      null
    )
    .then((response) => {
      // setDownloadDeliveryChallan(response.data);
      const url = URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      let iframe = document.createElement("iframe");
      document.body.appendChild(iframe);

      iframe.style.display = "none";
      iframe.src = url;
      iframe.onload = function () {
        setTimeout(function () {
          iframe.focus();
          iframe.contentWindow.print();
        }, 1);
      };
      // link.href = url;
      // link.setAttribute(
      //   "download",
      //   `Output.pdf`
      // );
      // document.body.appendChild(link);
      // link.click();
      // link.parentNode.removeChild(link);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}

export async function getAllInvoicePaymentsWithPaging(
  setDetails,
  pageNo = 0,
  pageSize = 0,
  stakeholderType,
  Status,
  searchText = "",
  // isClientSide = true,
  isExport = false,
  sortColumn = "",
  sortDirection = "",
  poNumber,
  // formattedFromDate,
  // formattedToDate,
  formattedDispatchedFromDate,
  formattedDispatchedToDate
) {
  loaderService.showLoader();
  let response = await apiClient.post(
    GET_INVOICE_PAYMENTS_WITH_PAGING,
    {
      loginId: localStorage.getItem("uuid"),
      paymentType: "",
      // ...(!isClientSide && {
      pageNumber: pageNo,
      pageSize: pageSize,
      // }),
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      filterText: searchText,
      stakeholderType: stakeholderType,
      status: Status,
      poNumber: poNumber,
      // fromDate: formattedFromDate,
      // toDate: formattedToDate,
      dispatchedFromDate: formattedDispatchedFromDate,
      dispatchedToDate: formattedDispatchedToDate
    },
    {
      headers: {
        Authorization: "Bearer " + getLocalStorageItem("id_token"),
      },
    },
    null
  );
  loaderService.hideLoader();
  if (isExport) {
    return response?.data?.invoicePayments;
  } else {
    setDetails(response.data.invoicePayments, response.data.totalCount);
  }
}
